import React, { useState } from "react";
import styled, { useTheme } from "styled-components";
import { Bio } from "../../Data/Constants.js";
import { MenuRounded } from "@mui/icons-material";
import { Tilt } from "react-tilt";

const Nav = styled.div`
  background: rgba(9, 9, 23, 0.92);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;
  color: white;
  backdrop-filter: blur(10px);
`;

const NavbarContainer = styled.div`
  width: 100%;
  max-width: 1280px;
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1rem;
`;

const NavLogo = styled.a`
  min-width: 220px;
  padding: 0 6px;
  font-weight: 700;
  font-size: 22px;
  text-decoration: none;
  color: ${({ theme }) => theme.text_primary};
  letter-spacing: 0.04em;
  animation: fadeIn 5s;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const NavItems = styled.ul`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  padding: 0 6px;
  list-style: none;
  margin: 0;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const NavLinkLi = styled.li`
  display: table-cell;
  position: relative;
  padding: 15px 0;
`;

const NavLink = styled.a`
  color: ${({ theme }) => theme.text_primary};
  text-transform: uppercase;
  text-decoration: none;
  letter-spacing: 0.12em;
  font-size: 16px;
  font-weight: 600;
  display: inline-block;
  padding: 10px 8px;
  position: relative;
  transition: all 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.primary};
  }

  &:after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 0;
    height: 2px;
    background: ${({ theme }) => theme.primary};
    transition: all 0.25s ease;
  }

  &:hover:after {
    left: 0;
    width: 100%;
  }
`;

const ButtonContainer = styled.div`
  min-width: 200px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 6px;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const GithubButton = styled.a`
  border: 2px solid ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primary};
  justify-content: center;
  display: flex;
  align-items: center;
  border-radius: 999px;
  cursor: pointer;
  padding: 12px 26px;
  font-size: 18px;
  font-weight: 600;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
  animation: fadeIn 5s;
  background: rgba(133, 76, 230, 0.04);

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  &:hover {
    background: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.text_primary};
    box-shadow: 0 0 18px rgba(133, 76, 230, 0.35);
  }
`;

const MobileIcon = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.text_primary};
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
  }
`;

const MobileMenu = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 16px;
  padding: 0 6px;
  list-style: none;
  width: 100%;
  padding: 12px 40px 24px 40px;
  background: ${({ theme }) => theme.card_light + 99};
  position: absolute;
  top: 80px;
  right: 0;

  transition: all 0.6s ease-in-out;
  transform: ${({ isOpen }) =>
    isOpen ? "translateY(0)" : "translateY(-100%)"};
  border-radius: 0 0 20px 20px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  opacity: ${({ isOpen }) => (isOpen ? "100%" : "0")};
  z-index: ${({ isOpen }) => (isOpen ? "1000" : "-1000")};
`;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();
  const name = "<Ido \\ sulam>";
  return (
    <Nav>
      <NavbarContainer>
        <NavLogo href="#About">{name}</NavLogo>

        <MobileIcon onClick={() => setIsOpen(!isOpen)}>
          <MenuRounded style={{ color: "inherit" }} />
        </MobileIcon>

        <NavItems>
          <NavLinkLi>
            <NavLink href="#About">About</NavLink>
          </NavLinkLi>
          <NavLinkLi>
            <NavLink href="#Skills">Skills</NavLink>
          </NavLinkLi>
          <NavLinkLi>
            <NavLink href="#Experience">Experience</NavLink>
          </NavLinkLi>
          <NavLinkLi>
            <NavLink href="#Projects">Projects</NavLink>
          </NavLinkLi>
          <NavLinkLi>
            <NavLink href="#Education">Education</NavLink>
          </NavLinkLi>
          <NavLinkLi>
            <NavLink href="#Certifications">Certifications</NavLink>
          </NavLinkLi>
        </NavItems>

        {isOpen && (
          <MobileMenu isOpen={isOpen}>
            <NavLink onClick={() => setIsOpen(!isOpen)} href="#About">
              About
            </NavLink>
            <NavLink onClick={() => setIsOpen(!isOpen)} href="#Skills">
              Skills
            </NavLink>
            <NavLink onClick={() => setIsOpen(!isOpen)} href="#Experience">
              Experience
            </NavLink>
            <NavLink onClick={() => setIsOpen(!isOpen)} href="#Projects">
              Projects
            </NavLink>
            <NavLink onClick={() => setIsOpen(!isOpen)} href="#Education">
              Education
            </NavLink>
            <NavLink onClick={() => setIsOpen(!isOpen)} href="#Certifications">
              Certifications
            </NavLink>
            <GithubButton
              href={Bio.github}
              target="_Blank"
              style={{
                background: theme.primary,
                color: theme.text_primary,
              }}
            >
              Github Profile
            </GithubButton>
          </MobileMenu>
        )}

        <ButtonContainer>
          <Tilt
            options={{
              max: 45,
              scale: 1,
              speed: 450,
            }}
          >
            <GithubButton href={Bio.github} target="_Blank">
              Github Profile
            </GithubButton>
          </Tilt>
        </ButtonContainer>
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
